export default "__VITE_ASSET__BhirPGz6__"